import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'calendars';

export const CALENDAR = createAsyncActionTypes(`${PREFIX}/CALENDAR`);
export const SET_CALENDAR = `${PREFIX}/SET_CALENDAR`;
export const SET_VISIBLE_RANGE = `${PREFIX}/SET_VISIBLE_RANGE`;